
class VideoEmbed {
    constructor(elem) {
        this.elem = elem;
        this.imageVideoContainer = this.elem.querySelector('.video-embed__video-image-container');
        this.ytID = this.imageVideoContainer.dataset.id;
    }

    init() {
        this.imageVideoContainer.addEventListener('click', () => {
            this.ytImageClickFunc(this.ytID);
        }, { once: true });
    }

    ytImageClickFunc() {
        var _mtm = _mtm || [];
        _mtm.push(
            {'event': 'Video', 'action': 'Start'}
        );
        this.createYouTubeIframe();

    }

    createYouTubeIframe() {
        this.imageVideoContainer.innerHTML = `<iframe title="yt-embed-${ this.ytID }" class="video-embed__video-iframe"
        width="833" height="468"
        src="https://www.youtube-nocookie.com/embed/${ this.ytID }?enablejsapi=1&autoplay=1"
        allow="autoplay" allowfullscreen=""></iframe>`;
    }
}

export default VideoEmbed;
